import type { RouteObject } from 'react-router';
import { NotFound } from './components/NotFound';
import { CreatePastePage } from './pages/CreatePastePage';
import { MyPastesPage } from './pages/MyPastesPage';
import { ViewPastePage } from './pages/ViewPastePage';

export const routes: RouteObject[] = [
  { index: true, element: <CreatePastePage /> },
  { path: 'p/:id', element: <ViewPastePage /> },
  { path: 'mine', element: <MyPastesPage /> },
  { path: '*', element: <NotFound /> },
];
